<template>
  <v-btn
    :class="`d-flex align-center justify-center rounded-pill ${$vuetify.breakpoint.xs ? 'rounded' : ''}`"
    :style="{
      background: '#fff !important',
      border: '2px solid #BFE3EA'
    }"
    @click="$emit('click')"
    v-if="visible"
  >
    <div :class="`px-${$vuetify.breakpoint.xs ? '0' : '2'} d-flex align-center`">
      <v-icon class="pa-0 ma-0">$sl-switch-account</v-icon>
      <span class="caption font-weight-bold text-none">
        {{ $vuetify.breakpoint.xs ? '' : 'Tillbaka till administratörsvyn' }}
        
      </span>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'SwitchAccountButton',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>